module.exports = __webpack_public_path__ + "static/media/ice37.e94e2c32.webp";